// extracted by mini-css-extract-plugin
export default {"BlankContract":"_BlankContract--Eqcat","Description":"_Description--yjXcR","Actions":"_Actions--XJG6C"};